import getBasePath from '../../../../../common/functions/api-resource';

const basePath = getBasePath('usuario', 'sso/grupo');

const grupoActions = {
  listar: { method: 'GET', url: `${basePath}` },
  obter: { method: 'GET', url: `${basePath}/{id}` },
  excluir: { method: 'DELETE', url: `${basePath}/{id}` },
  salvar: { method: 'PUT', url: `${basePath}` },
  adicionar: { method: 'POST', url: `${basePath}` },
};

export default resource => resource(`${basePath}`, {}, grupoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/sso/grupo.js